import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/apiClient";
import type { GRCReportGridResponse, GRCSearchResultWithFilters } from "@/types/grc";

// ─── Query keys ────────────────────────────────────────────────────────────────

export const grcKeys = {
  byMonth: (month: number, year: number) => ["grc", "grid", month, year] as const,
  search: (searchParam: string, isPast: boolean) =>
    ["grc", "search", searchParam, isPast] as const
};

// ─── Queries ──────────────────────────────────────────────────────────────────

export function useGRCData(month: number, year: number) {
  return useQuery({
    queryKey: grcKeys.byMonth(month, year),
    queryFn: () =>
      apiFetch<GRCReportGridResponse>(`GRC?month=${month}&year=${year}`),
    staleTime: 60_000,
    refetchOnMount: "always"
  });
}

/**
 * Autocomplete search – enabled only when searchParam.length >= 4.
 * Mirrors Blazor: ReadItems fires when input length >= 4.
 */
export function useGRCSearch(searchParam: string, isPast: boolean) {
  return useQuery({
    queryKey: grcKeys.search(searchParam, isPast),
    queryFn: () =>
      apiFetch<GRCSearchResultWithFilters>(
        `GRC/search?searchParam=${encodeURIComponent(searchParam)}&isPast=${isPast}`
      ),
    enabled: searchParam.length >= 4,
    staleTime: 30_000
  });
}
